import React from "react";
import styled, { css } from "styled-components";
import TypeSpecificValue from "views/components/TypeSpecificValue";
import useQueryFieldTypes from "views/hooks/useQueryFieldTypes";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
const ValueBox = styled.span(
  ({ theme, $bgColor }) => css`
    background-color: ${$bgColor != null ? $bgColor : "inherit"};
    color: ${$bgColor ? theme.utils.contrastingColor(String($bgColor)) : "inherit"};
    padding: ${theme.spacings.xxs};
  `
);
const Container = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    font-size: ${theme.fonts.size.tiny};
  `
);
const ValueRenderer = ({ value, field, traceColor }) => {
  const types = useQueryFieldTypes();
  const fieldType = fieldTypeFor(field, types);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ValueBox, { $bgColor: traceColor }, /* @__PURE__ */ React.createElement(TypeSpecificValue, { field, value, type: fieldType })), /* @__PURE__ */ React.createElement("span", null, field));
};
export default ValueRenderer;
